import { API_BASE_URLS } from "../config/api.config";

const BASE_PATH = "/QualityReview";

const getBackendUrl = () => {
  const baseUrl = API_BASE_URLS.backend || "";
  return baseUrl.replace(/\/$/, "");
};

const buildQualityFrameworkUrl = (path = "") => {
  return `${getBackendUrl()}${BASE_PATH}${path}`;
};

export const QUALITY_FRAMEWORK_ENDPOINTS = {
  GET_REQUESTS: buildQualityFrameworkUrl("/orders"),
  GET_ELIGIBLE_REVIEWERS: buildQualityFrameworkUrl("/eligible-reviewers"),
  ASSIGN_USERS: buildQualityFrameworkUrl("/assign"),
  GET_POPULATION_COUNT: (periodStartDate, periodEndDate) => buildQualityFrameworkUrl(`/population-summary-Count?PeriodStartDate=${periodStartDate}&PeriodEndDate=${periodEndDate}&Area=EMEIA`),
  GET_CHECKLIST_QUESTIONS: buildQualityFrameworkUrl("/checklist/questions"),
  GET_CHECKLIST_ANSWERS: (orderRequestId) => buildQualityFrameworkUrl(`/checklist/${orderRequestId}`),
  SUBMIT_CHECKLIST_ANSWERS: buildQualityFrameworkUrl("/checklist/submit"),
  IDENTIFY_POPULATION_DETAILS:  buildQualityFrameworkUrl(`/identify-population-details`),
  POPULATION_COUNT_DETAILS: buildQualityFrameworkUrl(`/population-count`),
  DELETE_RECORD: (recordId) => buildQualityFrameworkUrl(`/orders/${recordId}`),
};

export default QUALITY_FRAMEWORK_ENDPOINTS;
